module.exports = __webpack_public_path__ + "static/environmentally-friendly-car-painting-service-earth-smaller-ddfec3afe30cc076968d922710842eec.png";